/** Board-geometry state for the pull-plan grid + dep editor. These shapes are
 *  shared by the grid component, the pure draft mutators (draftOps.ts), and the
 *  draft hook (useDraft.ts) — the whole pull-plan draft subsystem. They are NOT
 *  the published draft payload (that's models/pullPlan/draftPayload.ts); they're
 *  the live canvas state autosaved alongside it as opaque geometry.
 */

/** One grid row = one Takt zone (A/B/C). */
export interface ZoneRow {
  rowId: string;
  takt_a: string;
  takt_b: string;
  takt_c: string;
}

/** A placed bar on the grid. `source_activity_id` is set for a committed
 *  activity; a freshly-pulled (draft-added) bar instead carries `draftId`,
 *  linking it to its pending_new_activities entry. */
export interface ActivityInstance {
  instanceId: string;
  rowId: string;
  activityKey: string;
  start_index: number;
  duration_days: number;
  source_activity_id: number | null;
  draftId?: string;
}

/** A persisted bar geometry: where a bar starts and how long it runs. Mirrors
 *  `BarSpan` in WbsBoardView/boardLayout — defined here so the draft load path
 *  can validate parsed JSON without reaching into the view layer. */
export interface SpanGeometry {
  startIndex: number;
  durationDays: number;
}

/** Validates a parsed JSON value carries numeric start/duration before it's
 *  trusted as bar geometry on draft load. */
export function isSpanGeometry(v: unknown): v is SpanGeometry {
  if (!v || typeof v !== "object") return false;
  const o = v as { startIndex?: unknown; durationDays?: unknown };
  return typeof o.startIndex === "number" && typeof o.durationDays === "number";
}
